/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../apimodel.d.ts" />
/// <reference path="../app.common.directives.module.ts" />
/// <reference path="validatorbase.ts" />
/// <reference path="validateargs.ts" />

module App.Common.Directives {
	'use strict';

	export class MustInclude extends Directives.ValidatorBase {

		public name = 'must-include';

		public isValid = (args: ValidateArgs): boolean => {
			return args.viewValue && args.viewValue().indexOf(args.parameter) > -1;
		};
		public resolveMessage = (args: ValidateArgs): string => {
			return `This field must contain "${args.parameter}"`;
		};
	}

	angular
		.module('app.common.directives')
		.directive('mustInclude', () => {return new MustInclude();});
}